import Vue from 'vue';
import visibility from 'vue-visibility-change';


// registry directive
Vue.use(visibility);
 
// global mode
const handler = visibility.change((evt, hidden) => {
  // do something

});
 
visibility.hidden(); // Return true if page now isn’t visible to user.
 
visibility.unbind(handler); // Remove `change` listener by it's handler.
 
visibility.isSupported(); // Return true if browser support Page Visibility API.


// WEBPACK FOOTER //
// ./src/visibility/index.js